module.exports = __webpack_public_path__ + "media/images/illustrations/light_bulb_rotated-70a6c17f2982fbf0dc14747ecdbfaf72.svg";